import { render, staticRenderFns } from "./EstablishmentStatus.vue?vue&type=template&id=32a14f8a&"
import script from "./EstablishmentStatus.vue?vue&type=script&lang=js&"
export * from "./EstablishmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports